import React, {useContext} from 'react';
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {MyContext} from "./MyContext";
import FilterSection from "./FilterSection";
import TableShow from "./TableShow";
import "./style.scss"
import "../BalanceSheet2/balacesheet2.scss"
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";

function CostAndBenefit2(props) {
  const contextData = MyContext

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const [data, setData] = objectDataHolder({
    dateFilter: {
      type: "1",
      startDate: "1402/06/10",
      endDate: "1402/06/25",
      year: "",
      month: "",
    },
    mainData: {
      column: [],
      part_1: {caption: "", data: []},
      part_2: {caption: "", data: []},
      part_3: {caption: "", data: []},
    },
  })

  const GoPrintPage = () => {
    const sendData = {
      type: "CostAndBenefitPrint",
      data: data,
    };
    setprint(sendData);
    navigate("/factorprint");
  }

  return (<MyContext.Provider value={{data, setData}}>
    <div className={"costAndbenefit2 costAndbenefit2__style  bg__white px-5"}>
      <FilterSection/>
      <TableShow/>

      <div className="button-row">
        <button
          className={"btn btn__secondary_purple wh104x28font14 p-0 m-2 my-5"}
          onClick={GoPrintPage}>چاپ </button>
      </div>
    </div>
  </MyContext.Provider>);
}

export default CostAndBenefit2;